import { resolveIconHref } from "../../../../features/icons/resolve-icon.js";
import type {
	DropdownUmbBlockElementModel,
	DropdownUmbBlockSettingsElementModel,
} from "#/_generated/umbraco/delivery-api/models";
import {
	Dropdown,
	type DropdownDirection,
	type DropdownIconPosition,
	type DropdownIntent,
	type DropdownItem,
	type DropdownProps,
	type DropdownVariant,
} from "#/_packages/umbrella/features/dropdown/components/dropdown";
import type { BlockItemProps } from "#/_packages/umbrella/integrations/umbraco/types";
import { getUmbLink } from "#/_packages/umbrella/integrations/umbraco/utils/link-utils.ts";
import { tryGetAnimationScrollType } from "#/_packages/umbrella/utils";

type DropdownBlockProps = BlockItemProps & {
	content: DropdownUmbBlockElementModel;
	settings: DropdownUmbBlockSettingsElementModel;
	isHeaderDrawer?: boolean;
};

export default function DropdownUmbBlock({
	className,
	content,
	settings,
}: DropdownBlockProps) {
	const icon = content.properties?.icon ? (
		<svg className="icon size-4" aria-hidden="true">
			<use
				href={resolveIconHref(content.properties.icon)}
			/>
		</svg>
	) : undefined;

	const dropdownItems: DropdownItem[] = (
		content.properties?.dropdownItems ?? []
	).map((apiLink, index) => {
		const link = getUmbLink(apiLink, {
			id:
				apiLink.url ??
				apiLink.title ??
				apiLink.route?.path ??
				`dropdown-item-${index}`,
		})!;

		return {
			id: link.id,
			name: link.label,
			url: link.href,
			target: link.target,
			trackingEvent: link.trackingEvent,
			noFollow: link.noFollow,
		};
	});

	return (
		<Dropdown
			id={settings.properties?.generatedId ?? content.id}
			textLabel={content.properties?.textLabel ?? undefined}
			icon={icon}
			iconPosition={
				(content.properties?.iconPosition as DropdownIconPosition) ?? undefined
			}
			size={(content.properties?.size as DropdownProps["size"]) ?? undefined}
			intentColor={
				(content.properties?.intentColor as DropdownIntent) ?? undefined
			}
			typeVariant={
				(content.properties?.typeVariant as DropdownVariant) ?? undefined
			}
			direction={
				(content.properties?.direction as DropdownDirection) ?? undefined
			}
			dropdownItems={dropdownItems}
			animationScrollType={tryGetAnimationScrollType(
				settings.properties?.animationScrollType,
				"none",
			)}
			className={className}
		/>
	);
}
